// Faktur Umum (general invoice) — API helpers.
// Dokumen ber-HARGA (item + harga + total); TIDAK mengubah stok. Backend di
// api-atalla-cms. Beda dengan Surat Jalan Umum (surat-jalan-umum/api.js).

export function apiBase() {
  return (process.env.REACT_APP_INVENTORY_API_URL || "").replace(/\/$/, "")
}

async function apiFetch(path, { method = "GET", body } = {}) {
  const access_token = localStorage.getItem("access_token") ?? ""
  const res = await fetch(`${apiBase()}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    },
    body: body ? JSON.stringify(body) : null,
  })

  const json = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = new Error(json?.message || "Request gagal")
    err.status = res.status
    err.validation = json?.errors || null
    throw err
  }
  return json
}

export function insertFakturUmum(payload, createdBy) {
  return apiFetch("/faktur-umum", {
    method: "POST",
    body: { ...payload, createdBy },
  })
}

export function updateFakturUmum(id, payload, updatedBy) {
  return apiFetch(`/faktur-umum/${id}`, {
    method: "PUT",
    body: { ...payload, updatedBy },
  })
}

export function showFakturUmum(id) {
  return apiFetch(`/faktur-umum/${id}`)
}

export function deleteFakturUmum(id, deletedBy) {
  return apiFetch(`/faktur-umum/${id}`, {
    method: "DELETE",
    body: { deletedBy },
  })
}

export function printFakturUmumUrl(id) {
  return `${apiBase()}/faktur-umum/${id}/print`
}

// 240726 (permintaan user): menu SJU digabung ke Faktur Umum — cetak surat jalan
// (format persis fitur Surat Jalan Umum lama, tanpa harga) dari faktur.
export function printSuratJalanUmumUrl(id) {
  return `${apiBase()}/faktur-umum/${id}/print-surat-jalan`
}
